import PersonalChange from "./personal";
import CompanyChange from "./company";

const InfoChange = ({ accountType, riskLevel, canPeriodic, reviewUUID }) => {
  return (
    <>
      {accountType === "PERSONAL" && (
        <PersonalChange
          riskLevel={riskLevel}
          canPeriodic={canPeriodic}
          reviewUUID={reviewUUID}
        />
      )}
      {accountType === "COMPANY" && (
        <CompanyChange
          canPeriodic={canPeriodic}
          reviewUUID={reviewUUID}
          riskLevel={riskLevel}
        />
      )}
    </>
  );
};

export default InfoChange;
